import { useAuth } from "@/auth";
import { Auth0PluginOptions } from "@/auth/auth0";
import { PluginObject } from "vue";

export const AuthPlugin: PluginObject<Auth0PluginOptions> = {
  install(Vue, options = {} as Auth0PluginOptions) {
    Vue.prototype.$auth = useAuth(options);
  },
};
